import { check } from './validate';
import { required, isEmail } from './validate/rules';

export default [
  check("email", "Die E-Mail-Adresse", required, isEmail),
]